import axios from "axios";
import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import frontDeskFormMap from "../front-desk/front-desk-form-map";

const DashboardChart = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [completedTasks, setCompletedTasks] = useState(0);
    const chartConfig = {
        plugins: {
            legend: {
                display: false,
            },
        },
        cutout:"70%"
    };

    const data = {
        datasets: [
            {
                data: [completedTasks, 100-completedTasks],
                backgroundColor: ["hsla(138, 55%, 55%, 1)", "hsla(350, 85%, 67%, 1)"],
            },
        ],
        labels : [
            "Completed Tasks",
            "Pending Tasks"
        ]
    };

    useEffect(() => {
        setIsLoading(true);
        var config = {
            method: "post",
            url: dataProvider.baseUrl + "forms-getFrontdeskFormData",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
                "Content-Type": "application/x-www-form-urlencoded",
            },
        };
        // console.log(config);
        axios(config)
            .then(function (response) {
                setIsLoading(false);
                // console.log(response)
                if(response.data.status === "success") {
                    let data = response.data?.message ;
                    let total = 0 ;
                    Object.keys(data || {}).forEach(key=>{
                        if(!data[key]?.overdue)
                            total += frontDeskFormMap[key].weightage ;
                    })
                    setCompletedTasks(total);
                } else {
                    console.error("unable to fetch")
                }
            })
            .catch(function (error) {
                setIsLoading(false);
                console.error(error);
            });
    }, []);

    return (
        <div className="container-fluid p-3 h-100">
            <div className="card border-0 h-100">
                <div className="card-header py-3 d-flex bg-white align-items-center justify-content-between">
                    <b>Compliance Overview</b>
                </div>
                <div className="card-body p-3 d-flex align-items-center justify-content-center">
                    {isLoading ? (
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Data</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center">
                            <div className="position-relative" style={{ width: "256px" }}>
                                <Doughnut width="256" data={data} options={chartConfig} />
                                <div className="position-absolute text-center top-50 start-50 translate-middle">
                                    Completion Rate
                                    <div className="fw-bold text-black-50" style={{fontSize:"2rem"}}>{completedTasks}%</div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center ms-0 ms-lg-5 mt-3 mt-lg-0">
                                <div>
                                    <div className="text-black-50 d-flex align-items-center">  
                                        <span className="d-inline-block" style={{width:"1rem",height:"1rem",borderRadius:"50%",backgroundColor:"hsla(138, 55%, 55%, 1)"}}></span>
                                        <b className="ms-3" style={{width:"13ch"}}>Completed Tasks</b>
                                        <span className="ms-5 border-start border-2 ps-3" style={{width:"6ch"}}>{completedTasks}%</span>
                                    </div>
                                    <div className="text-black-50 d-flex align-items-center mt-3">  
                                        <span className="d-inline-block" style={{width:"1rem",height:"1rem",borderRadius:"50%",backgroundColor:"hsla(350, 85%, 67%, 1)"}}></span>
                                        <b className="ms-3" style={{width:"13ch"}}>Pending Tasks</b>
                                        <span className="ms-5 border-start border-2 ps-3" style={{width:"6ch"}}>{100-completedTasks}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DashboardChart;
